import { getViewport } from "./CornerstoneViewportService";

export const addKeyImages = async (
  activeViewportIndex,
  keyImages,
  setKeyImages,
  newKeyImageTitle
) => {
  const viewport = await getViewport(activeViewportIndex);
  const imageURL = viewport.getCurrentImageId();

  const keyImage = {
    imageUrl: imageURL,
    keyImageTitle: newKeyImageTitle,
    state: "UNSAVED",
  };

  setKeyImages([...keyImages, keyImage]);
};

export const deleteKeyImages = (keyImageTitle, keyImages, setKeyImages) => {
  console.log(keyImageTitle)
  let tempKeyImages = keyImages.map((keyImage) => {
    if(keyImage.keyImageTitle === keyImageTitle) {
      console.log("Found ket images")
      return {...keyImage, state: "DELETED"};
    }
    return keyImage;
  })

  console.log(keyImages);
  console.log(tempKeyImages);

  setKeyImages(tempKeyImages);
}

export const saveKeyImages = (keyImageTitle, newImageTitle, keyImages, setKeyImages) => {
  let tempKeyImages = keyImages.map((keyImage) => {
    if(keyImage.keyImageTitle === keyImageTitle) {
      return {...keyImage, state: "UPDATED", keyImageTitle: newImageTitle};
    }
    return keyImage;
  })

  console.log(keyImages);

  setKeyImages(tempKeyImages);
}

export const isKeyImageTitleAlreadyPresent = (keyImages, keyTitle) => {
  for (let i = 0; i < keyImages.length; i++) {
    if (keyImages[i].keyImageTitle === keyTitle && keyImages[i].state !== "DELETED") {
      return true;
    }
  }
  return false;
};

export const isKeyImageAlreadyPresent = (activeViewport, keyImages) => {
  // const viewport = await getViewport(activeViewportIndex);
  const imageURL = activeViewport.getCurrentImageId();
  for (let i = 0; i < keyImages.length; i++) {
    if (keyImages[i].imageUrl === imageURL && keyImages[i].state !== "DELETED") {
      return true;
    }
  }

  return false;
};

export const maxKeyImageValidation = (keyImages) => {
  let count = 0;
  for (let i = 0; i < keyImages.length; i++) {
    if (
      keyImages[i].state === "SAVED" ||
      keyImages[i].state === "UNSAVED" ||
      keyImages[i].state === "UPDATED"
    ) {
      count++;
    }
  }
  return count < 6;
};


export const keyImagesPresent = (keyImages) => {
  for( let i=0 ; i<keyImages.length ; i++) {
    if (
      keyImages[i].state === "SAVED" ||
      keyImages[i].state === "UNSAVED" ||
      keyImages[i].state === "UPDATED"
    ) {
      return true;
    }
  }
  return false;
}